import { render, staticRenderFns } from "./NavSubMenu.vue?vue&type=template&id=811d4aa4"
import script from "./NavSubMenu.vue?vue&type=script&lang=js"
export * from "./NavSubMenu.vue?vue&type=script&lang=js"
import style0 from "./NavSubMenu.vue?vue&type=style&index=0&id=811d4aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports